export enum Tabs {
	Risks = 'risks',
	RiskSettings = 'riskSettings',
	Threats = 'threats',
	Vulnerabilities = 'vulnerabilities',
}
